{
  "approval": {
    "title": "الموافقات",
    "subtitle": "مراجعة الناشرين المنتظرين والموافقة عليهم أو رفضهم",
    "pendingCount": "{{count}} ناشر بانتظار الموافقة",
    "emptyTitle": "لا توجد موافقات معلقة",
    "emptyDesc": "جميع الناشرين المسجلين تمت مراجعتهم",
    "loadError": "فشل تحميل قائمة الناشرين",
    "loadMore": "تحميل المزيد",
    "fields": {
      "publisher": "الناشر",
      "country": "البلد",
      "registeredAt": "تاريخ التسجيل",
      "actions": "الإجراءات",
      "status": "الحالة"
    },
    "actions": {
      "approve": "موافقة",
      "reject": "رفض",
      "view": "عرض التفاصيل",
      "restore": "استعادة"
    },
    "approveSuccess": "تمت الموافقة على الناشر بنجاح",
    "approveError": "فشل الموافقة على الناشر",
    "rejectSuccess": "تم رفض الناشر بنجاح",
    "rejectError": "فشل رفض الناشر",
    "retry": "إعادة المحاولة",
    "statusError": "فشل تحديث الحالة",
    "emptyWaiting": "لا يوجد ناشرون بانتظار الموافقة",
    "emptyRejected": "لا يوجد ناشرون مرفوضون",
    "emptyAccepted": "لا يوجد ناشرون معتمدون",
    "emptySuspended": "لا يوجد ناشرون موقوفون",
    "status": {
      "waiting": "بانتظار المراجعة",
      "rejected": "مرفوض",
      "accepted": "معتمد"
    }
  },
  "adminTitles": {
    "title": "جميع العناوين",
    "subtitle": "إدارة ومراجعة جميع عناوين الكتب على المنصة",
    "sectionLabel": "الإدارة",
    "searchPlaceholder": "بحث بالعنوان أو المؤلف أو الرقم المعياري...",
    "footerLabel": "عنوان",
    "export": "تصدير",
    "addTitle": "إضافة عنوان",
    "allOrganizations": "جميع المنظمات",
    "tabs": {
      "all": "الكل",
      "published": "منشور",
      "pending": "بانتظار",
      "editing": "قيد التحرير",
      "suspended": "معلّق",
      "revisions": "مراجعة التعديلات"
    },
    "columns": {
      "title": "العنوان",
      "author": "المؤلف",
      "publisher": "الناشر",
      "status": "الحالة",
      "dateAdded": "تاريخ الإضافة"
    },
    "toast": {
      "approveSuccess": "تمت الموافقة على العنوان",
      "suspendSuccess": "تم تعليق العنوان",
      "reactivateSuccess": "تم إعادة تفعيل العنوان",
      "statusError": "فشل تحديث حالة العنوان",
      "activateSuccess": "تم تفعيل العنوان",
      "deactivateSuccess": "تم إلغاء تفعيل العنوان",
      "billingError": "فشل تحديث تفعيل العنوان"
    }
  },
  "revisionReview": {
    "queueSub": "تعديلات مُقدَّمة من الناشرين على عناوين معتمدة مسبقاً. راجع كل تغيير قبل نشره.",
    "submittedBy": "أرسلها",
    "reviewBtn": "مراجعة التغييرات",
    "footerLabel": "عناوين بانتظار المراجعة",
    "empty": {
      "title": "لا توجد مراجعات",
      "desc": "ستظهر هنا تعديلات الناشرين بانتظار المراجعة."
    },
    "columns": {
      "changes": "التغييرات",
      "submitted": "تاريخ التقديم"
    },
    "changes": "تغييرات",
    "files": "ملفات",
    "needsAttention": "يحتاج انتباهاً",
    "fieldsChanged": "حقول مُعدَّلة",
    "filesReplaced": "ملفات مُستبدَلة",
    "loadError": "فشل تحميل هذه المراجعة",
    "retry": "إعادة المحاولة",
    "back": "العودة إلى القائمة",
    "statusReview": "معتمد · تغييرات قيد المراجعة",
    "submitted": "قُدِّم",
    "viewMode": "نمط العرض",
    "viewSplit": "جنباً إلى جنب",
    "viewInline": "مدمج",
    "current": "الحالي",
    "currentSub": "معتمد · منشور",
    "proposed": "المُقترَح",
    "proposedSub": "من الناشر",
    "was": "كان",
    "now": "أصبح",
    "validated": "تم التحقق",
    "invalid": "فشل التحقق",
    "showUnchanged": "إظهار الحقول غير المتغيرة",
    "hideUnchanged": "إخفاء الحقول غير المتغيرة",
    "approveBtn": "اعتماد التغييرات",
    "approvedBtn": "تم الاعتماد",
    "rejectBtn": "رفض",
    "approvedBanner": "تم اعتماد التغييرات — العنوان منشور",
    "actionHint": "الاعتماد يطبّق هذه التعديلات؛ يبقى العنوان معتمداً ويُنشر مباشرة.",
    "kbNav": "التنقل بين التغييرات",
    "kbApprove": "اعتماد",
    "tags": {
      "added": "مُضاف",
      "changed": "مُعدَّل",
      "removed": "محذوف",
      "file": "ملف"
    },
    "reject": {
      "title": "الرفض والإعادة إلى الناشر",
      "subtitle": "أضف ملاحظة توضّح ما يجب تغييره. سيراها الناشر ويمكنه إعادة التقديم.",
      "placeholder": "اشرح ما الذي يحتاج إلى تعديل قبل الاعتماد…",
      "quick": [
        "صورة الغلاف فشلت في التحقق",
        "عدد الصفحات يحتاج تأكيداً",
        "الملخص قصير جداً",
        "استعادة الموضوع المحذوف"
      ],
      "cancel": "إلغاء",
      "send": "إرسال الرفض"
    },
    "history": {
      "title": "سجل المراجعات",
      "count": "مراجعات سابقة",
      "approved": "تم الاعتماد",
      "rejected": "تم الرفض",
      "reviewedBy": "راجعها"
    },
    "fields": {
      "title": "العنوان",
      "arabicTitle": "العنوان العربي",
      "isbn13": "ردمك-13",
      "isbn10": "ردمك-10",
      "language": "اللغة",
      "coverPaperType": "ورق الغلاف",
      "yearOfPublication": "سنة النشر",
      "edition": "الطبعة",
      "pages": "عدد الصفحات",
      "authors": "المؤلفون",
      "subjects": "الموضوعات",
      "bindingTypes": "أنواع التجليد",
      "distributionChannels": "قنوات التوزيع",
      "interiorPaperType": "الورق الداخلي",
      "synopsis": "الملخص",
      "arabicSynopsis": "الملخص العربي",
      "manuscript": "ملف المخطوطة PDF",
      "coverArtwork": "فنية الغلاف",
      "coverImage": "صورة الغلاف",
      "publisherName": "الناشر",
      "contributors": "المساهمون",
      "coverType": "نوع الغلاف",
      "interiorColour": "لون المحتوى الداخلي",
      "ageGroup": "الفئة العمرية",
      "educationalStage": "المرحلة الدراسية",
      "category": "الصنف",
      "keywords": "كلمات مفتاحية",
      "price": "السعر",
      "copiesAvailableShipping": "النسخ المتاحة للشحن",
      "returnsCount": "عدد المرتجعات",
      "unsoldCopies": "النسخ غير المباعة",
      "datePublished": "تاريخ النشر"
    }
  },
  "publishers": {
    "title": "الناشرون",
    "subtitle": "إدارة جميع الناشرين المسجلين على المنصة",
    "adminSectionLabel": "الإدارة",
    "searchPlaceholder": "بحث بالناشر أو الشركة...",
    "footerLabel": "ناشر",
    "export": "تصدير",
    "tabs": {
      "all": "الكل",
      "waiting": "في الانتظار",
      "current": "الحالي",
      "suspended": "معلّق"
    },
    "fields": {
      "publisher": "الناشر",
      "email": "البريد الإلكتروني",
      "country": "البلد",
      "location": "الموقع",
      "registeredAt": "تاريخ التسجيل",
      "registered": "تاريخ التسجيل",
      "status": "الحالة",
      "actions": "الإجراءات",
      "suspend": "تعليق",
      "organization": "المنظمة"
    },
    "status": {
      "waiting": "في الانتظار",
      "rejected": "مرفوض",
      "accepted": "نشط",
      "approved": "موافق عليها",
      "pending": "بانتظار",
      "suspended": "معلّق"
    },
    "actions": {
      "approve": "موافقة",
      "reject": "رفض",
      "restore": "استعادة",
      "activate": "تفعيل",
      "noAction": "لا إجراءات",
      "retry": "إعادة المحاولة",
      "select": "تحديد الناشر",
      "selectAll": "تحديد جميع الناشرين",
      "suspendSuccess": "تم تعليق الناشر بنجاح",
      "suspendError": "فشل تعليق الناشر",
      "reactivateSuccess": "تم إعادة تفعيل الناشر بنجاح",
      "reactivateError": "فشل إعادة تفعيل الناشر",
      "view": "عرض التفاصيل"
    },
    "empty": {
      "waiting": "لا يوجد ناشرون بانتظار الموافقة",
      "current": "لا يوجد ناشرون نشطون بعد",
      "suspended": "لا يوجد ناشرون معلّقون"
    },
    "errors": {
      "loadFailed": "فشل تحميل الناشرين. يرجى المحاولة مرة أخرى."
    },
    "sectionLabel": "النشر"
  },
  "dashboard": {
    "title": "لوحة تحكم المسؤول",
    "subtitle": "نظرة عامة على أداء المنصة",
    "eyebrow": "نظرة عامة على المنصة",
    "welcome": "مرحبًا بك",
    "exportReport": "تصدير التقرير",
    "fields": {
      "title": "العنوان",
      "publisher": "الناشر",
      "status": "الحالة",
      "waiting": "الانتظار",
      "actions": "الإجراءات",
      "dateAdded": "تاريخ الإضافة"
    },
    "recentTitles": "العناوين الأخيرة",
    "workProgress": "تقدم العمل",
    "viewAll": "عرض الكل",
    "viewAllN": "عرض الكل {{count}} ←",
    "export": "تصدير",
    "newTitle": "عنوان جديد",
    "status": {
      "published": "منشور",
      "draft": "مسودة",
      "pending": "بانتظار الموافقة"
    },
    "progress": {
      "coverDesign": "تصميم الأغلفة",
      "contentReview": "مراجعة المحتوى",
      "pdfPreparation": "إعداد ملفات PDF",
      "ftpTransfer": "نقل FTP للمتاجر"
    },
    "kpi": {
      "totalPublishers": "إجمالي الناشرين",
      "activeInactive": "{{active}} نشط · {{inactive}} غير نشط",
      "totalTitles": "إجمالي العناوين"
    },
    "submissionActivity": "نشاط التقديم",
    "chart": {
      "titlesAdded": "عناوين مُضافة",
      "publishersAdded": "ناشرون جُدد",
      "period6m": "6 أشهر",
      "period3m": "3 أشهر"
    },
    "breakdown": {
      "perPlan": "الناشرون حسب الخطة",
      "byCategory": "العناوين حسب التصنيف",
      "byAgeGroup": "العناوين حسب الفئة العمرية",
      "topPublishers": "أبرز الناشرين",
      "empty": "لا توجد بيانات بعد"
    },
    "plan": {
      "basic": "أولي",
      "standard": "عادي",
      "premium": "مميز",
      "enterprise": "مؤسسي",
      "none": "بدون خطة"
    },
    "approvalQueue": {
      "title": "قائمة الانتظار للموافقة",
      "pending": "{{n}} معلّق",
      "viewAll": "عرض الكل",
      "viewAllN": "عرض الكل {{n}} ←",
      "sortedNote": "مرتب بحسب الأقدم أولًا — الأكثر إلحاحًا في الأعلى",
      "approve": "اعتماد",
      "review": "مراجعة"
    },
    "waiting": {
      "urgent": "{{days}} أيام — عاجل",
      "mid": "{{days}} أيام — راجع قريبًا",
      "ok": "{{days}} أيام"
    }
  },
  "stats": {
    "activeTitles": "العناوين النشطة",
    "activeTitlesDelta": "3 هذا الشهر",
    "manuscripts": "المخطوطات",
    "manuscriptsDelta": "2 بانتظار المراجعة",
    "filesProcessing": "ملفات قيد المعالجة",
    "filesProcessingDelta": "2 اليوم",
    "users": "المستخدمون",
    "usersDelta": "مشرف + محرران"
  },
  "sidebar": {
    "dashboard": "لوحة التحكم",
    "titles": "العناوين",
    "publishers": "الناشرون",
    "manuscripts": "المخطوطات",
    "covers": "أغلفة الكتب",
    "ftp": "التصدير FTP",
    "users": "المستخدمون",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج",
    "sectionDashboard": "المحتوى",
    "management": "الإدارة",
    "adminPanel": "لوحة الإدارة"
  },
  "enterprise": {
    "sectionLabel": "الفوترة",
    "title": "خطط المؤسسات",
    "subtitle": "إنشاء صفقات مؤسسية مخصصة وإدارة حصص العناوين.",
    "provisionTitle": "إنشاء اشتراك مؤسسي",
    "provisionSubtitle": "أنشئ اشتراكًا مؤسسيًا مخصصًا وأرسل للناشر رابط الدفع.",
    "updateQuotaTitle": "تحديث حصة المؤسسة",
    "updateQuotaSubtitle": "إعادة تحديد حصة العناوين لناشر مؤسسي حالي.",
    "publisher": "الناشر",
    "publisherPlaceholder": "اختر ناشرًا",
    "interval": "دورة الفوترة",
    "monthly": "شهري",
    "annual": "سنوي",
    "amount": "المبلغ (دولار أمريكي)",
    "amountPlaceholder": "مثال: ٤٩٩",
    "titleQuota": "حصة العناوين",
    "titleQuotaPlaceholder": "مثال: ٢٥٠",
    "unlimited": "غير محدود",
    "provision": "إنشاء",
    "provisioning": "جارٍ الإنشاء…",
    "updateQuota": "تحديث الحصة",
    "updatingQuota": "جارٍ التحديث…",
    "checkoutLink": "رابط الدفع",
    "checkoutLinkHelp": "أرسل هذا الرابط إلى الناشر لإتمام الدفع.",
    "copy": "نسخ",
    "copied": "تم النسخ",
    "copyFailed": "تعذّر نسخ الرابط. انسخه يدويًا.",
    "provisionSuccess": "تم إنشاء الصفقة المؤسسية. شارك رابط الدفع أدناه.",
    "provisionError": "تعذّر إنشاء الصفقة المؤسسية. يرجى المحاولة مرة أخرى.",
    "quotaSuccessLimited": "تم تحديث الحصة إلى {{count}} عنوان.",
    "quotaSuccessUnlimited": "تم تحديث الحصة إلى عناوين غير محدودة.",
    "quotaError": "تعذّر تحديث الحصة. يرجى المحاولة مرة أخرى.",
    "amountError": "أدخل مبلغًا أكبر من صفر.",
    "checkoutResultTitle": "رابط الدفع لـ {{publisher}}",
    "checkoutResultSummary": "{{interval}} · {{quota}} · أرسله إلى الناشر لإتمام الدفع.",
    "checkoutQuotaUnlimited": "عناوين غير محدودة",
    "checkoutQuotaCount": "{{count}} عنوان"
  },
  "toast": {
    "undo": "تراجع",
    "dismiss": "إغلاق"
  },
  "profileSectionLabel": "الحساب",
  "profileTitle": "الملف الشخصي",
  "profileSubtitle": "تفاصيل حساب المسؤول الخاص بك",
  "profileNotFound": "تعذر تحميل الملف الشخصي.",
  "email": "البريد الإلكتروني",
  "role": "الدور",
  "roleAdmin": "مدير",
  "roleUser": "مستخدم",
  "status": "الحالة",
  "publisherId": "معرّف الناشر",
  "comingSoon": {
    "title": "قريبًا",
    "description": "هذه الصفحة قيد التطوير."
  },
  "titles": {
    "pageTitle": "الموافقة على العناوين",
    "pageSubtitle": "مراجعة عناوين الناشرين والموافقة عليها أو رفضها",
    "tabs": {
      "pending": "بانتظار المراجعة",
      "active": "نشط",
      "all": "الكل"
    },
    "fields": {
      "title": "العنوان",
      "publisher": "الناشر",
      "isbn": "الرقم المعياري",
      "submitted": "تاريخ التقديم",
      "actions": "الإجراءات",
      "language": "اللغة",
      "pageCount": "عدد الصفحات"
    },
    "searchPlaceholder": "بحث بالعنوان أو المؤلف أو الرقم المعياري...",
    "emptyTitle": "لا توجد عناوين",
    "emptyDesc": "لم يتم العثور على عناوين في هذا التصنيف",
    "loadError": "فشل تحميل العناوين",
    "count": "{{count}} عنوان",
    "review_button": "مراجعة",
    "approve_button": "موافقة",
    "reject_button": "رفض",
    "close_panel": "إغلاق اللوحة",
    "isbn_manual_entry": "إدخال يدوي",
    "printSpecs": "مواصفات الطباعة",
    "printSpecsPaperType": "نوع الورق",
    "printSpecsTrimSize": "المقاس",
    "printSpecsBinding": "التجليد",
    "printSpecsLamination": "الطلاء",
    "printSpecsSpecialFinish": "التشطيب الخاص",
    "printSpecsCoverType": "نوع الغلاف",
    "reject_modal_title": "رفض: {{title}}",
    "reject_modal_desc": "يرجى تقديم سبب الرفض.",
    "reject_reason_label": "رسالة إلى الناشر",
    "reject_reason_optional": "اختياري",
    "reject_reason_placeholder": "ما الذي ينبغي على الناشر تعديله قبل إعادة التقديم؟ (اختياري)",
    "reject_reason_help": "تُرسل إلى الناشر وتظهر في بوابته.",
    "reject_empty_confirm_title": "الرفض دون إبداء سبب؟",
    "reject_empty_confirm_desc": "لن يعرف الناشر ما الذي يجب تعديله — فقط أن العنوان أُعيد إليه.",
    "reject_add_reason_button": "إضافة سبب",
    "reject_anyway_button": "الرفض على أي حال",
    "cancel_button": "إلغاء",
    "reject_confirm_button": "رفض العنوان",
    "toast_approved": "تمت الموافقة على العنوان بنجاح",
    "toast_rejected": "تم رفض العنوان بنجاح",
    "toast_error": "حدث خطأ. يرجى المحاولة مرة أخرى.",
    "kpi_total": "إجمالي العناوين",
    "kpi_pending": "بانتظار المراجعة",
    "kpi_approved": "موافق عليها",
    "kpi_editing": "قيد التحرير",
    "panel_title_review": "مراجعة العنوان",
    "actions": {
      "view": "عرض",
      "approve": "موافقة",
      "reject": "رفض",
      "suspend": "تعليق",
      "reactivate": "إعادة تفعيل",
      "delete": "حذف",
      "activate": "تفعيل",
      "deactivate": "إلغاء التفعيل"
    }
  },
  "close": "إغلاق",
  "editPublisher": "تعديل الناشر",
  "loading": "جارٍ التحميل...",
  "contactPerson": "جهة الاتصال",
  "recentTitles": "العناوين الأخيرة",
  "account": "الحساب",
  "defaultRoyalty": "الحقوق الافتراضية",
  "notes": "ملاحظات",
  "totalTitles": "إجمالي العناوين",
  "drafts": "المسودات",
  "contactInfo": "بيانات التواصل",
  "internalCode": "الرمز الداخلي",
  "contractRef": "مرجع العقد",
  "adminOnly": "للمسؤولين فقط",
  "admin": "مسؤول",
  "joined": "تاريخ الانضمام",
  "address": "العنوان",
  "phone": "الهاتف",
  "website": "الموقع الإلكتروني",
  "contact": "التواصل",
  "inCatalogue": "في الكتالوج",
  "noTitles": "لا توجد عناوين",
  "titleColumn": "العنوان",
  "back": "رجوع",
  "backToPublishers": "العودة إلى الناشرين",
  "publisher_not_found": "الناشر غير موجود",
  "editing": "قيد التحرير",
  "saveChanges": "حفظ التغييرات",
  "discard": "تجاهل",
  "editBtn": "تعديل",
  "suspend": "تعليق",
  "saving": "جارٍ الحفظ...",
  "catalogue": "الكتالوج",
  "pages": "الصفحات",
  "added": "تاريخ الإضافة",
  "pending": "قيد الانتظار",
  "published": "منشور",
  "publisher": "الناشر",
  "edit": {
    "publisherIdentity": "هوية الناشر",
    "arabicName": "الاسم بالعربية",
    "englishName": "الاسم بالإنجليزية",
    "internalNotes": "ملاحظات داخلية",
    "companyName": "اسم الشركة",
    "fullName": "الاسم الكامل",
    "country": "البلد",
    "countryPlaceholder": "اختر البلد",
    "taxNumber": "الرقم الضريبي",
    "account": "الحساب",
    "savedSuccessfully": "تم حفظ بيانات الناشر بنجاح",
    "status": "الحالة"
  },
  "settings": {
    "sectionLabel": "الإعدادات",
    "pageTitle": "الإعدادات",
    "pageSubtitle": "إدارة الإشعارات واللغة والمظهر",
    "notifications": {
      "sectionTitle": "الإشعارات",
      "webPush": {
        "label": "إشعارات فورية",
        "description": "إشعارات في المتصفح"
      },
      "emailPush": {
        "label": "البريد الإلكتروني",
        "description": "إشعارات عبر البريد الإلكتروني"
      },
      "testPush": "اختبار Push",
      "testPushDone": "تم الإرسال!",
      "testEmail": "اختبار البريد",
      "testEmailDone": "تم الإرسال!",
      "statusDenied": "محظور — أعد التعيين عبر أيقونة 🔒 في شريط العنوان"
    },
    "language": {
      "sectionTitle": "اللغة",
      "rowLabel": "اللغة",
      "arCurrent": "العربية (الحالية)",
      "enCurrent": "الإنجليزية (الحالية)"
    },
    "appearance": {
      "sectionTitle": "المظهر",
      "rowLabel": "المظهر",
      "lightDescription": "وضع فاتح",
      "darkDescription": "وضع داكن",
      "systemDescription": "تبع النظام",
      "light": "فاتح",
      "dark": "داكن",
      "system": "النظام"
    }
  },
  "mobile": {
    "of": "من",
    "view": "عرض",
    "edit": "تعديل",
    "delete": "حذف",
    "language": "اللغة",
    "pages": "الصفحات",
    "isbn": "رقم ISBN",
    "email": "البريد الإلكتروني",
    "website": "الموقع الإلكتروني",
    "tradingAs": "الاسم التجاري",
    "primaryContact": "جهة الاتصال الأساسية",
    "total": "الإجمالي",
    "published": "منشور",
    "pipeline": "قيد النشر",
    "emptyTitle": "لا توجد عناوين مطابقة",
    "emptyDesc": "جرّب فلتر حالة مختلف، أو امسح الفلاتر لرؤية كل العناوين.",
    "emptyPublishersTitle": "لا توجد ناشرون مطابقون",
    "emptyPublishersDesc": "جرّب فلتر حالة مختلف، أو امسح الفلاتر لرؤية كل الناشرين.",
    "showAll": "عرض كل العناوين",
    "showAllPublishers": "عرض كل الناشرين"
  },
  "adminLegal": {
    "sectionLabel": "إدارة",
    "title": "الوثائق القانونية",
    "subtitle": "كتابة ونشر إصدارات شروط الخدمة وسياسة الخصوصية.",
    "newVersion": "إصدار جديد",
    "searchPlaceholder": "البحث بالعنوان أو الملخص أو الإصدار (مثال: v1)…",
    "footerOf": "من",
    "deleteConfirm": "حذف هذه المسودة؟ لا يمكن التراجع عن هذا الإجراء.",
    "notFound": "لم يتم العثور على الوثيقة.",
    "versionShort": "إصدار {{version}}",
    "tabs": {
      "all": "الكل",
      "draft": "مسودات",
      "published": "منشورة",
      "archived": "مؤرشفة"
    },
    "filters": {
      "allTypes": "كل الأنواع",
      "allLanguages": "كل اللغات"
    },
    "docType": {
      "terms": "شروط الخدمة",
      "privacy": "سياسة الخصوصية"
    },
    "language": {
      "ar": "العربية",
      "en": "الإنجليزية"
    },
    "columns": {
      "title": "العنوان",
      "docType": "النوع",
      "language": "اللغة",
      "version": "الإصدار",
      "status": "الحالة",
      "effectiveAt": "تاريخ السريان",
      "publishedAt": "تاريخ النشر"
    },
    "actions": {
      "view": "عرض",
      "edit": "تحرير",
      "delete": "حذف",
      "cancel": "إلغاء",
      "saveDraft": "حفظ المسودة",
      "saving": "جارٍ الحفظ…",
      "publishNow": "نشر الآن",
      "publishing": "جارٍ النشر…",
      "unpublish": "إلغاء النشر",
      "unpublishing": "جارٍ الإلغاء…",
      "preview": "معاينة",
      "createNewVersion": "إصدار جديد"
    },
    "editor": {
      "source": "المصدر",
      "history": "السجل",
      "saveDraft": "حفظ المسودة",
      "inSync": "متزامن",
      "current": "الحالي",
      "versions": "سجل الإصدارات",
      "versionsCount_zero": "لا توجد إصدارات",
      "versionsCount_one": "إصدار واحد",
      "versionsCount_two": "إصداران",
      "versionsCount_few": "{{count}} إصدارات",
      "versionsCount_many": "{{count}} إصداراً",
      "versionsCount_other": "{{count}} إصدار",
      "closeHistory": "إغلاق السجل",
      "openVersion": "فتح النسخة {{version}}",
      "saveNote": "حفظ الملاحظة",
      "noNote": "لا توجد ملاحظة",
      "staleTranslation": "قد تكون هذه الترجمة غير محدّثة. يُنصح بتحديثها لتتوافق مع المصدر.",
      "unsavedSwitchConfirm": "لديك تغييرات غير محفوظة. هل تريد تبديل اللغة وتجاهلها؟",
      "tabs": {
        "missing": "مفقودة",
        "stale": "قديمة"
      },
      "publishModal": {
        "title": "نشر الوثيقة",
        "notifications": "الإشعارات",
        "emailPublishers": "إشعار الناشرين بالبريد الإلكتروني",
        "emailPublishersDesc": "إرسال بريد إلكتروني لجميع الناشرين النشطين عند نشر هذا الإصدار.",
        "statusNow": "سيتم نشر هذا الإصدار فورًا.",
        "confirmNow": "نشر الآن"
      }
    },
    "empty": {
      "title": "لا توجد وثائق مطابقة",
      "desc": "جرّب فلترًا مختلفًا، أو امسح الفلاتر لرؤية كل الوثائق.",
      "showAll": "عرض الكل"
    },
    "meta": {
      "sectionLabel": "بيانات الوثيقة",
      "docType": "النوع",
      "language": "اللغة",
      "version": "الإصدار",
      "effectiveAt": "تاريخ السريان",
      "publishedAt": "تاريخ النشر",
      "createdBy": "المؤلف",
      "created": "أُنشئ في",
      "updated": "آخر تحديث",
      "changeSummary": "ملخص التغييرات",
      "changeSummaryPlaceholder": "ما الذي تغيّر في هذا الإصدار؟",
      "changeSummaryHelp": "يُعرض على الناشرين عند نشر هذا الإصدار."
    },
    "edit": {
      "back": "العودة إلى الوثائق",
      "createEyebrow": "إصدار جديد",
      "editEyebrow": "تحرير الإصدار {{version}}",
      "untitledDoc": "وثيقة بلا عنوان",
      "docType": "نوع الوثيقة",
      "language": "اللغة",
      "docTitle": "عنوان الوثيقة",
      "docTitlePlaceholder": "مثال: شروط الخدمة",
      "contentPlaceholder": "اكتب محتوى الوثيقة بصيغة ماركداون…",
      "previewLabel": "معاينة مباشرة",
      "previewEmpty": "ابدأ الكتابة لرؤية المعاينة المباشرة."
    },
    "deleteDialogTitle": "حذف الوثيقة"
  },
  "language": "اللغة",
  "view": "عرض",
  "common": {
    "errors": {
      "generic": "حدث خطأ. يرجى المحاولة مرة أخرى."
    }
  },
  "publisherStatus": {
    "approved": "نشط",
    "pending": "معلق",
    "suspended": "موقوف"
  }
}
